<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增职级' : '编辑职级'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form
      :formConfig="formConfig"
      v-model="form"
      @submit="doSubmit"
      @cancelForm="cancel"
      ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
  import {  addRank, edit } from '@/api/quarters.js'
  import DragDialog from '@/components/DragDialog'
  import '@/components/dynamic-form';
  export default {
    props: {
      isAdd: {
        type: Boolean,
        required: true
      },
      supThis: {
        type: Object,
      }
    },
    components: {
      DragDialog
    },
    watch: {
      treeData: function(val) {
        this.$nextTick(() => {
          this.$set(this.formConfig.formItemList[1], 'options', val)
        })
      },
      dialog(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.pageForm.$refs.dynamicForm.clearValidate();
          });
        }
      }
    },
    created() {
      this.getPermissions()
    },
    data() {
      return {
        loading: false, dialog: false,
        form: {},
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "name",
              label: "岗位名称",
              placeholder: "请输入名称",
              rules: [
                { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: 'textarea',
              maxlength: '500',
              showWordLimit: true,
              validateEvent: true,
              key: 'remark',
              label: '备注',
              value: '',
              placeholder: '请输入备注'
            }
          ]
        },
        treeData: []
      }
    },
    methods: {
      cancel() {
        this.resetForm()
      },
      doSubmit(val) {
        this.form = val;
        console.log('form',this.form);
        if (this.isAdd) {
          this.doAdd()
        } else this.doEdit()
      },
      doAdd() {
        addRank(this.form).then(res => {
          this.resetForm();
          this.$notify({
            title: '添加成功',
            type: 'success',
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
          this.getPermissions()
        }).catch(err => {
          this.loading = false;
          console.log(err)
        })
      },
      doEdit() {
        edit(this.form).then(res => {
          this.resetForm();
          this.$notify({
            title: '修改成功',
            type: 'success',
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        }).catch(err => {
          this.loading = false;
          console.log(err.response.data.message)
        })
      },
      resetForm() {
        this.dialog = false;
        this.$refs.pageForm.resetForm()
      },
    }
  }
</script>

<style scoped>

</style>
